/**
 * Otel listesi bağlamı: select_item tetiklenen sayfanın item_list_id / item_list_name değerleri.
 * Detay sayfasında view_item ve add_to_cart event'lerinde "nereden geldiği" ile senkron tutulması için
 * localStorage'da saklanır; select_item atıldığında yazılır, detay sayfasında okunur.
 */

const STORAGE_KEY = "turna_hotel_list_context";

/**
 * @param {string} itemListId
 * @param {string} itemListName
 */
export function setHotelListContext(itemListId, itemListName) {
  try {
    if (typeof window === "undefined") return;
    const payload = {
      item_list_id: itemListId ?? "hotel_search",
      item_list_name: itemListName ?? "Hotel Search",
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // localStorage full / private mode vb.
  }
}

/**
 * @returns {{ item_list_id: string, item_list_name: string } | null}
 */
export function getHotelListContext() {
  try {
    if (typeof window === "undefined") return null;
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      parsed &&
      typeof parsed.item_list_id === "string" &&
      typeof parsed.item_list_name === "string"
    ) {
      return {
        item_list_id: parsed.item_list_id,
        item_list_name: parsed.item_list_name,
      };
    }
    return null;
  } catch {
    return null;
  }
}
